import { useContext, useEffect, useState } from "react";
import { OidcIdentityContext } from "@rsmus/react-auth";
import BulkSitesCreationToggle from "../../cui/commonComponents/BulkSitesCreationToggle";
import "./BulkSiteCreation.scss";
import { BulkSitesGrid } from "./BulkSitesGrid";
import { LoadExcelFileModal } from "./LoadExcelFileModal";

export const BulkSiteCreation = () => {
  const [isBulkSiteMainPage, setBulkSiteMainPage] = useState<boolean>(true);
  const { user } = useContext(OidcIdentityContext);
  const userEmail = user?.profile.preferred_username!;

  return (
    <div>
      {isBulkSiteMainPage ? (
        <div className="grid-container">
          <div className="grid-header">
            <h2>Create Sites in Batch</h2>
            <BulkSitesCreationToggle />
          </div>
          <BulkSitesGrid
            userEmail={userEmail}
            setBulkSiteMainPage={setBulkSiteMainPage}
          />
        </div>
      ) : (
        <div className="grid-container">
          <div className="grid-header">
            <h2>Create Sites in Batch Excel Requests</h2>
          </div>
          <LoadExcelFileModal 
            setBulkSiteMainPage={setBulkSiteMainPage} />
        </div>
      )}
    </div>
  );
};
